import React from 'react';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { NavigationRuntimeProvider } from '@/components/navigation/NavigationRuntimeBridge';
import { NavigationThemeProvider } from '@/components/navigation/NavigationThemeProvider';
import { ThemeProvider } from '@/components/admin/shared/ThemeEngine'; // ✅ إضافة نظام الألوان
import ReactErrorBoundary from "@/components/debug/ReactErrorBoundary";
import { AppRouter } from '@/routes/AppRouter'; // استخدام النظام الموحد
import IntroWrapper from '@/components/intro/IntroWrapper';
import DirectionGuard from '@/components/DirectionGuard';
// تم تعطيل systemTest و PreviewToggle حسب طلب المالك لتقليل الضجيج في الكونسول
// import '@/utils/systemTest';
// import PreviewToggle from '@/components/admin/PreviewToggle';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes
      gcTime: 5 * 60 * 1000, // 5 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (error && typeof error === 'object' && 'status' in error) {
          const status = (error as { status?: number }).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      networkMode: 'online'
    },
    mutations: {
      retry: 1,
      networkMode: 'online'
    },
  },
});

const App = () => {
  console.log('🚀 App: بدء التطبيق مع النظام الموحد');
  
  return (
    <ReactErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <LanguageProvider>
            <DirectionGuard />
            <ThemeProvider>
              <NavigationRuntimeProvider>
                <NavigationThemeProvider>
                  <TooltipProvider>
                    <IntroWrapper enableIntro={true}>
                      <Toaster />
                      <Sonner />
                      {/* استخدام AppRouter الموحد بدلاً من الـ Routes المتضاربة */}
                      <AppRouter />
                    </IntroWrapper>
                  </TooltipProvider>
                </NavigationThemeProvider>
              </NavigationRuntimeProvider>
            </ThemeProvider>
          </LanguageProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ReactErrorBoundary>
  );
};

export default App;
